import { render, staticRenderFns } from "./FormStats.vue?vue&type=template&id=71ea057e"
import script from "./FormStats.vue?vue&type=script&lang=js"
export * from "./FormStats.vue?vue&type=script&lang=js"
import style0 from "./FormStats.vue?vue&type=style&index=0&id=71ea057e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports